// extracted by mini-css-extract-plugin
export var letter = "tabs-panel-module--letter--XjPgn";
export var letterBtn = "tabs-panel-module--letter-btn--UX9mN";
export var tabsPanel = "tabs-panel-module--tabs-panel--m2h5v";